/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const ParkAssist = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 24 24" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M13.72 8.51a2.38 2.38 0 0 0-.61-.23H11.5v3.67h1c.3.007.598-.04.88-.14a1.6 1.6 0 0 0 .93-1.01 2 2 0 0 0 .12-.77 2 2 0 0 0-.2-.94 1.29 1.29 0 0 0-.51-.58z" /><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12A12 12 0 0 0 12 0zm4.43 11.45a3 3 0 0 1-.82 1.18 3.63 3.63 0 0 1-1.34.74 6.05 6.05 0 0 1-1.86.26h-.91v3.45a.22.22 0 0 1-.06.16.5.5 0 0 1-.18.11 1.35 1.35 0 0 1-.34.07H9.85a1.35 1.35 0 0 1-.34-.07.38.38 0 0 1-.17-.11.31.31 0 0 1-.06-.16V7.33a.84.84 0 0 1 .2-.58.78.78 0 0 1 .54-.2h3.3c.283.021.564.065.84.13a4 4 0 0 1 1 .35c.32.168.608.392.85.66a2.9 2.9 0 0 1 .54.92c.133.382.198.785.19 1.19a4.29 4.29 0 0 1-.31 1.65z" /></g>
      </g>
    </svg>
  </span>
);

ParkAssist.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

ParkAssist.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default ParkAssist;
